import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class UserEvents extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			userEvents: [],
		};
	}

	componentDidMount() {
		this.loadEvents();
	}

	loadEvents() {
		var _this = this;
		Axios.get('/api/userEvents').then(function(response) {
			_this.setState({
				userEvents: response.data
			});
		});
	}

	render() {
		// console.log('UserEvents: render');
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Événements Utilisateurs</h5>
				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>
						Événements
					</div>

					<div className="card-block table-responsive">
						<table className="table table-striped table-hover table-sm">
						<tbody>
							<tr>
								<th>Date</th>
								<th>Event</th>
								<th>Type</th>
								<th>User Name</th>
								<th>Reference</th>
								<th>Sandbox</th>
							</tr>
							{this.state.userEvents.map(this.createEventsRow)}
						</tbody>
						</table>
					</div>
				</div>
			</div>
			</div>
		);
	}

	createEventsRow(userEvent, getEventIdx) {
		return (
			<tr key={userEvent._id}>
				<td>{moment(userEvent.date).format("YYYY-MM-DD HH:mm:ss")}</td>
				<td>{userEvent.type}</td>
				<td>{userEvent.typeStr}</td>
				<td>{userEvent.userName}</td>
				<td>{userEvent.reference}</td>
				<td>{userEvent.sandbox}</td>
		   </tr>
		);
	}

}

export default UserEvents;